import { CancelToken } from 'axios'

import { ReportAPI, TicketAPI } from 'api'
import { cancelCatcher, mapResponse } from 'utils/api'

import { IQueryConfig, IQueryOptions } from '../query/types'

import { getQuery } from './queries'

export const fetchSimpleReport = (
  queryConfig: IQueryConfig,
  options?: IQueryOptions,
  cancelToken?: CancelToken
) => {
  const { query, parseFunction } = getQuery(queryConfig, options)

  if (
    ['overallCSATRating', 'csatByRating', 'csatByTeammate'].includes(
      queryConfig.metric
    )
  ) {
    return ReportAPI.post(
      `/conversation-summary/report/simple/support?metric=${queryConfig.metric}`,
      query,
      {
        cancelToken,
      }
    )
      .then(mapResponse)
      .then((response) => parseFunction(response, queryConfig, options))
      .catch(cancelCatcher)
  }

  return ReportAPI.post(
    `support/report/deflection?metric=${queryConfig.metric}`,
    query,
    {
      cancelToken,
    }
  )
    .then(mapResponse)
    .then((response) => parseFunction(response, queryConfig, options))
    .catch(cancelCatcher)
}

export const fetchOrgServiceStatus = (cancelToken?: CancelToken) => {
  return TicketAPI.get(`/service-metrics`, {
    cancelToken,
  })
    .then(mapResponse)
    .catch(cancelCatcher)
}
